import { computed } from "vue";

export const isIndieKonnect = computed(() => {
  const currentUrl = window.location.href.toLowerCase();
  return ["indiekonnect", "ecom"].some((keyword) => currentUrl.includes(keyword));
});